var map = {
	"./amex.png": 75666,
	"./diners.png": 60154,
	"./discover.png": 73666,
	"./jcb.png": 13747,
	"./mastercard.png": 12290,
	"./unionpay.png": 96746,
	"./unknown.png": 59680,
	"./visa.png": 10406
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1237;